module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point3_3-89d5658e15fed94a0cf033e5ccf1ca94.jpg";